import * as _ from 'lodash'
import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, ISearchSort, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_Product_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Master Data Set Wb Id', columnResourceName: 'colMDSetWbId', alignment: HorizAlignment.Center},
        domainOptions: {}
    },
    WB_PROD_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center},
        domainOptions: {}
    },
    PRODUCT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    PRODUCT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    PRODUCT_SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Set ID', columnResourceName: 'colSetID', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 10}
    },
    SOURCE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Source ID', columnResourceName: 'colSourceID', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    // PRODUCT_TYPE:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Type', columnResourceName: 'colProductType', alignment: HorizAlignment.Left}, domainOptions: { domainIds: "Product_Type", useIdAsKey: true, maxLength: 50}},
    WB_PROD_TYPE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Product Type',
            columnResourceName: 'colWBProductType',
            alignment: HorizAlignment.Left
        },
        domainOptions: {domainIds: "Product_Type", useIdAsKey: true, maxLength: 50}
    },
    PRODUCT_UPC: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Product UPC', columnResourceName: 'colProductUPC', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    CONSUMER_PRODUCT_UPC: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Cons Product UPC',
            columnResourceName: 'colConsProductUPC',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    STATUS_CODE: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Status Code', columnResourceName: 'colStatusCode', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    WEIGHT_FACTOR: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Weight Factor',
            columnResourceName: 'colWeightFactor',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
};


class ProductSearchByMDSetProvider
    implements ISearchProvider {
    _wbMDSetId: number = undefined

    constructor(wbMDSetId?: number) {
        this._wbMDSetId = wbMDSetId
    }

    keyFields = {
        id: 'WB_PROD_ID',
        id_ui: 'PRODUCT_ID',
        name: 'PRODUCT_NAME'
    }


    searchProviderFields = vUI_Product_Search_Fields
    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            if (this._wbMDSetId > 0)
                searchOptions.where.WB_MDSET_ID = this._wbMDSetId


            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Product_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let query: { where: { [id: string]: any } } = {where: {}}
            if (this._wbMDSetId > 0)
                query.where.WB_MDSET_ID = this._wbMDSetId

            let findRequest = SearchUtils.makeSearchRequest(query,
                'vUI_Product_Search',
                this.searchProviderFields,
                [fieldName])

            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                findRequest.where['WB_MDSET_ID'] = {inq: _.map(usrContext.WB_MasterDataSets, 'WB_MDSET_ID')}
            }

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}

class ProductSearchByMDSetProfile
    implements ISearchProfile {
    aSearchProvider: ISearchProvider = undefined
    profileId = "default"
    profileName = "Search by Id, Name"
    renderOptions = {ui5ResourceId: "ProductSearchByMDSetProfile"}

    profileFilter = [
        {profileFilterName: 'Id', searchProviderFieldId: 'PRODUCT_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PRODUCT_NAME', renderOptions: {}},
        {profileFilterName: 'Set ID', searchProviderFieldId: 'PRODUCT_SET_ID', renderOptions: {}},
        // {profileFilterName: 'Product Type',     searchProviderFieldId: 'PRODUCT_TYPE',bMultiSelect: true, renderOptions: { }},
        {
            profileFilterName: 'Product Type',
            searchProviderFieldId: 'WB_PROD_TYPE_ID',
            bMultiSelect: true,
            renderOptions: {}
        },
        {profileFilterName: 'Product UPC', searchProviderFieldId: 'PRODUCT_UPC', renderOptions: {}},
        {profileFilterName: 'Consumer UPC', searchProviderFieldId: 'CONSUMER_PRODUCT_UPC', renderOptions: {}},
        {profileFilterName: 'Status Code', searchProviderFieldId: 'STATUS_CODE', renderOptions: {}}

    ]  // ISearchFields
    profileDisplayFields = [
        'PRODUCT_ID', 'PRODUCT_NAME', 'PRODUCT_SET_ID', 'SOURCE_ID', 'WB_PROD_TYPE_ID', 'PRODUCT_UPC', 'CONSUMER_PRODUCT_UPC', 'STATUS_CODE'
    ] //string[];   // Search Provider Field Name (Use to Generate Grid Columns)


    profileTreeIdDefault = "default"
    profileTrees = [
        {
            treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {
                defaultValues: "Tree Path not set",
                levelDelimiter: "\\",
                ruggedTree: true
            })],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}
        }
    ]
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault = ""
    profileSorts: ISearchSort[] = []

    constructor(wbMDSetId: number) {
        this.aSearchProvider = new ProductSearchByMDSetProvider(wbMDSetId)
    }

    get profileSearchProvider() {
        return this.aSearchProvider
    }

}

export class ProductSearchByMDSet
    implements ISearch {
    constructor(wbMDSetId?: number) {
        this.searchProfiles = [new ProductSearchByMDSetProfile(wbMDSetId)]
    }

    searchName = "Select Product(s)"
    renderOptions = {ui5ResourceId: "ProductSearchByMDSet"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []

}